/*
 * @Descripttion:
 * @version:
 * @Author: Yj
 * @Date: 2023-03-06 09:54:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-07 10:44:36
 */
/*
 * @author: zhangning
 * @date: 2022/3/7 11:23
 * @Description: 登录接口
 **/
import Http from '../../plugins/axiosHttp';
import { RSA_SIGNATURE } from '@/utils/client';
import { getDomainAfterForward,platformFlagFn} from '@/utils/index'
// 登录
export function login(params) {
  return Http.jsonPost('uc/core/user/login.json', params);
}

// 登录加密
export function decryLogin(params) {
  return Http.jsonPost('uc/core/user/userLogin.json', params);
}

// 退出登录
export function logout() {
  return Http.post('uc/core/user/logout.json', {});
}
// 发送手机验证码
export function sendPCode(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  return Http.jsonPost('uc/code/sendpcode.json', params, BYUData);
}

// 发送手机验证码加密
export function sendDecryPCode(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  const { user, cipher1, cipher2, salt } = params;
  return Http.jsonPost(
    'uc/code/sendTelCode.json',
    { user, cipher1, cipher2, salt },
    BYUData
  );
}

// 发送手机验证码
export function sendEmailCode(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  return Http.jsonPost('uc/code/sendECode.json', params, BYUData);
}

// 发送邮箱验证码加密
export function decrySendECode(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  const { user, cipher1, cipher2, salt } = params;
  return Http.jsonPost(
    'uc/code/sendEmailCode.json',
    { user, cipher1, cipher2, salt },
    BYUData
  );
}

// 手机验证码登录
export function codeLogin(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  return Http.jsonPost('uc/core/user/lbCode.json', params, BYUData);
}

// 手机验证码登录加密
export function decryLbCode(params) {
  const BYUData = RSA_SIGNATURE({ tel: params.tel, type: 'login' });
  const { user, cipher1, cipher2, salt } = params;
  return Http.jsonPost(
    'uc/core/user/loginByCode.json',
    { user, cipher1, cipher2, salt },
    BYUData
  );
}

// 手机注册
export function phoneRegister(params) {
  return Http.jsonPost('uc/core/user/registerSave.json', params);
}

// 手机注册加密
export function decryRegisterSave(params) {
  return Http.jsonPost('uc/core/user/registerUser.json', params);
}

// 邮箱注册
export function emailRegister(params) {
  return Http.jsonPost('uc/core/user/registerByEmail.json', params);
}

// 邮箱注册加密
export function decryRegisterByEmail(params) {
  return Http.jsonPost('uc/core/user/registerUserByEmail.json', params);
}

// 轮询校验小程序是否登录
export function xcxCheckLogin(params,signal) {
  return Http.jsonPostSignal('uc/wx/checkLogin.json', params,signal);
}

// 找回密码
export function resetPwd(params) {
  return Http.jsonPost('uc/userInfo/findPwd.json', params);
}

// 找回密码加密
export function decryFindPwd(params) {
  return Http.jsonPost('uc/userInfo/retrievePwd.json', params);
}

//校验弱类型
export function isWeakPwd(params) {
  return Http.jsonPost('uc/core/user/isWeakPwd.json', params);
}

//校验弱类型加密
export function decryIsWeakPwd(params) {
  return Http.jsonPost('uc/core/user/checkIsWeakPwd.json', params);
}

//获取公钥
// export function getKyberSMKey() {
//   return Http.get('api/taskApi/getPublicKey.json');
// }

export function getKyberSMKey() {
  return Http.get('api/taskApi/cryptogram.json');
}

// 后端生成key
export function generateKey(params) {
  return Http.jsonPost('api/taskApi/generateKey.json', params);
}

//用户中心获取公钥
// export function getKyberSMKeyCore() {
//   return Http.get('uc/core/user/getPublicKey.json');
// }

export function getKyberSMKeyCore() {
  return Http.get('uc/core/user/cryptogram.json');
}


// 用户中心后端生成key
export function generateKeyCore(params) {
  return Http.jsonPost('uc/core/user/generateKey.json', params);
}

// 用户信息解密
export function encryUserInfo(data) {
  return Http.jsonPost('uc/userInfo/userInfo.json',data);
}

// 轮询校验注册页面服务号是否登录
export function wxRCheckLogin(params,signal) {
  return Http.jsonPostSignal('uc/wx/checkRegister.json', params,signal);
}
// 轮询校验服务号是否登录
export function serviceCheckLogin(params, signal) {
  return Http.jsonPostSignal('uc/wx/checkBind.json', { scene: params }, signal);
}

// export function getLoginBackground(data) {
//   console.log(window.location, getDomainAfterForward(window.location.href), 'location')
//   const platform = getDomainAfterForward(window.location.href);
//   console.log(platform,'platform')
// //  const platform =  platformFlagFn(domain)
//   return Http.get(`api/background/getLoginBackground.json?platformFlag=${platform}`,data);
// }